import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Immutable from 'seamless-immutable';
import { ChecklistItemChecking } from '../../components';

const INITIAL_STATE = {
  checklistItemIndex: 0,
  score: 0,
  selectedAnswers: Immutable({}),
};

class Checklist extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    //Wenn selectedChecklist gesetzt ist, dann müssen die ChecklistItems geladen werden
    if (this.props.checklist && this.props.selectedChecklistRun) {
      this.props.loadChecklistItemAnswers(this.props.selectedChecklistRun.Id); // Die Antworten auf die ChecklistItems werden geladen
      return;
    }
    //Wenn selectedChecklist nicht gesetzt ist, dann wird die ChecklistId aus der URL ausgelesen
    this.props.selectChecklist({
      id: parseInt(this.props.match.params.checklistId),
    });

    //Wenn die ChecklistId aus der URL ausgelesen werden konnte, dann wird die Checkliste geladen
    if (this.props.match.params.checklistId) {
      this.props.loadChecklist({
        id: this.props.match.params.checklistId,
      });
    }

    // Wenn bereits ein ChecklistRun für die Checkliste existiert und das EndDate null ist (d.h. noch nicht abgeschlossen), dann wird der ChecklistRun geladen
    if (
      this.props.checklist &&
      !this.props.checklistRuns.some(
        (c) => c.checklistId === this.props.checklist.id && c.endDate === null
      )
    ) {
      // Wenn noch kein ChecklistRun für die Checkliste existiert, dann wird ein neuer ChecklistRun erstellt
      if (this.props.checklist)
        this.props.startNewChecklistRun(this.props.checklist);
    }
  }

  render() {
    return (
      <ChecklistItemChecking
        checklistItems={this.props.checklistItems}
        completed={this.props.completed}
        onRestart={this.props.onRestart}
        onExportContent={this.props.onExportContent}
        checklistRun={this.props.selectedChecklistRun}
        onSubmitAnswer={this.props.onSubmitAnswer}
        onSubmitChecklist={this.props.onSubmitChecklist}
        checklist={this.props.checklist}
        checklists={this.props.checklists}
        isLoading={this.props.isLoading}
        location={this.props.location}
        onOpenResults={() => this.props.history.push('/results')}
        onOpenChecklists={() => this.props.history.push('/checklists')}
      />
    );
  }
}

Checklist.propTypes = {
  checklistItems: PropTypes.array,
  completed: PropTypes.bool,
  onRestart: PropTypes.func,
  checklistRuns: PropTypes.array,
  onSubmitAnswer: PropTypes.func,
  onSubmitChecklist: PropTypes.func,
  checklist: PropTypes.object,
  checklists: PropTypes.array,
  isLoading: PropTypes.bool,
  location: PropTypes.any,
  history: PropTypes.any,
  match: PropTypes.any,
  loadChecklist: PropTypes.func,
  loadResult: PropTypes.func,
  startNewChecklistRun: PropTypes.func,
  selectChecklist: PropTypes.func,
  selectedChecklistRun: PropTypes.object,
  onExportContent: PropTypes.func,
  loadChecklistItemAnswers: PropTypes.func,
  loadChecklists: PropTypes.func,
};

Checklist.defaultProps = {
  checklistRuns: null,
  checklist: null,
  location: null,
  match: null,
  history: null,
  isLoading: false,
  completed: false,
  checklists: [],
  checklistItems: [],
  onRestart: () => {},
  onLoadCard: () => {},
  onCloseLinkedCard: () => {},
  onSubmitAnswer: () => {},
  onSubmitChecklist: () => {},
  loadChecklist: () => {},
  loadResult: () => {},
  loadChecklists: () => {},
};

export default Checklist;



// WEBPACK FOOTER //
// ./src/app/main/checklist/checklist.js